import ApiAgentInterface from "./ApiAgentInterface";

class ApiAgentReqInFlightDecorator extends ApiAgentInterface {
    constructor(apiAgent, queryParamStringStrategy) {
        super();
        this.apiAgent = apiAgent;
        this.queryParamStringStrategy = queryParamStringStrategy;
        this.requestStorage = {};
    }

    get = async (path, queryParam={}) => {
        const queryParamString = this.queryParamStringStrategy.build(queryParam);
        const completePath = path + queryParamString;

        if (!this.requestStorage[completePath]) {
            this.requestStorage[completePath] = {
                promise: this.apiAgent.get(path, queryParam),
                incoming_count: 0
            }
        }

        this.requestStorage[completePath].incoming_count++;

        const result = await Promise.resolve(this.requestStorage[completePath].promise);
        
        this.requestStorage[completePath].incoming_count--;
        if (this.requestStorage[completePath].incoming_count === 0) {
            delete this.requestStorage[completePath];
        }

        return result;
    }

    post = (path, data, queryParam={}) => {
        return this.apiAgent.post(path, data, queryParam);
    }

}

export default ApiAgentReqInFlightDecorator;